import React from 'react';
import { useSelector } from 'react-redux';
import block from 'bem-cn';

import './Subheader.scss';

const b = block('subheader');

const Subheader = () => {
  const locale = useSelector(state => state.locale.locale);
  const currency = useSelector(state => state.auth.currency);
  const { limits } = useSelector(state => state.game);

  return <article className={b()}>
      <div className={b('title')}>
        {locale.plinko}
      </div>
    <div className={b('info')}>
      <div className={b('info-item')}>
        {`${locale.minBet}: ${limits.min} ${currency}`}
      </div>
      <div className={b('info-item')}>
        {`${locale.maxBet}: ${limits.max} ${currency}`}
      </div>
      <div className={b('info-item')}>
        {`${locale.maxWin}: ${limits.win} ${currency}`}
      </div>
    </div>
  </article>
}

export default Subheader;